import { ChannelPermission, Channel } from '../types/working-model';
import { Get, Put, Post } from './helpers';

export const authLogin = async (email: string, password: string, two_factor_stored: string | null): Promise<any> => {
	return Post('/v3/admin/auth/sign-in', '', { email, password, two_factor_stored: (two_factor_stored ? two_factor_stored : "") }, false, {}, true)
		.then(async res => {
			if (res.status === 403) {
				throw new Error('incorrect email/password');
			}

			const response = await res.json();

			if (response.needs_verification) {
				throw new Error('nopassword');
			}

			if (response.reset_required) {
				throw new Error('a password that is old');
			}

			return response;
		});
};

export const tempPhone = async (phone: string, temp_profile: string): Promise<any> => {
	return Post('/v3/admin/auth/set-temp-phone', '', { temp_profile, phone });
};

export const authCode = async (temp_profile: string, code: string, should_confirm: boolean, request_storage: boolean): Promise<any> => {
	return Post('/v3/admin/auth/confirm-code', '', { temp_profile, code, should_confirm, request_storage }, false, {}, true)
		.then(res => {
			if (res.status === 403) {
				throw new Error('incorrect confirmation code given');
			}

			const response = res.json();

			return response;
		});
};

export const ForgotPassword = async (email: string, hostname: string): Promise<any> => {
	return Post('/v3/admin/auth/forgot-password', '', { email, hostname }, false, {}, true)
		.then(res => {
			if (res.ok) {
				return res.ok;
			}

			throw new Error('Forgot Password Failure');
		});
};

export const UpdatePassword = async (password: string, code: string, cb: () => void): Promise<any> => {
	return Put('/v3/admin/auth/forgot-password', '', { password, code }, false, true)
		.then(res => {
			if (res.ok) {
				cb();

				return res.ok;
			}

			throw new Error('Password Reset Failure');
		});
};

export const RefreshToken = async (token: string): Promise<any> => {
	return Get('/v3/admin/auth/refresh-token', token, {}, true)
		.then(res => {
			if (res.ok) {
				return res.json();
			}

			throw new Error('Unable To Refresh Token');
		});
};

export function GetChannels(token: string): Promise<any> {
	return Get('/v3/admin/auth/channels', token);
}

export function SelectChannel(token: string, channel: number): Promise<any> {
	return Post('/v3/admin/auth/channels', token, { channel });
}

export function GetAdmins(token: string): Promise<any[]> {
	return Get(`/v3/admin/auth/admins`, token);
}

export function UpdateChannels(token: string, id: number, channels: ChannelPermission): Promise<any> {
	return Put(`/v3/admin/auth/update-channels`, token, { id, channels }, true);
}

export function UpdateChannel(token: string, channel: Channel): Promise<Channel> {
	return Put(`/v3/admin/auth/update-channel`, token, { channel }, true);
}

export const UpdateOnboarding = async (token: string, id: number, onboarding: string[], newItem: string): Promise<any> => {
	onboarding.push(newItem);

	return Put('/v3/admin/auth/update-onboarding', token, { id, onboarding }, false, true)
		.then(res => {
			if (res.ok) {
				return res.json();
			}

			throw new Error('Unable To Get Response');
		});
};

export function ResetOnboarding(token: string, id: number): Promise<any> {
	return Put(`/v3/admin/auth/clear-onboarding`, token, { id });
}

export function AddNewAdmin(token: string, email: string, permissions: string[]): Promise<any> {
	return Post(`/v3/admin/auth/add-admin`, token, { email, permissions });
}

export const SetAdminPassword = async (password: string, hashCode: string, cb: () => void): Promise<any> => {
	return Post('/v3/admin/auth/set-password', '', { hashCode, password }, false, {}, true)
		.then(res => {
			if (res.ok) {
				cb();

				return res.ok;
			}

			throw new Error('Password Set Failure');
		});
};